/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const termsEditorActionEditor = {
	commands: {
		toggleLeftPanel: "actionEditor:commands.toggleLeftPanel#label",
		toggleRightPanel: "actionEditor:commands.toggleRightPanel#label",
		hideAllPanels: "actionEditor:commands.hideAllPanels#label",
		toggleConsole: "actionEditor:commands.toggleConsole#label",
		saveResource: "actionEditor:commands.saveResource#label",
		exportYaml: "actionEditor:commands.exportYaml#label",
		undo: "actionEditor:commands.undo#label",
		redo: "actionEditor:commands.redo#label"
	},
	mainMenu: {
		sectionCreate: {
			action: {
				label: "actionEditor:mainMenu.sectionCreate.action#label",
				tooltip: "actionEditor:mainMenu.sectionCreate.action#tooltip"
			}
		}
	},
	inspector: {
		selectNodeToInspect: "actionEditor:inspector.selectNodeToInspect",
		cannotEditMultipleNodes: "actionEditor:inspector.cannotEditMultipleNodes"
	},
	actionSettings: {
		label: "actionEditor:actionSettings#label",
		openDocumentation: "actionEditor:actionSettings.openDocumentation#label"
	},
	toasts: {
		savingAction: "actionEditor:toasts.savingAction#message",
		actionHasBeenSaved: "actionEditor:toasts.actionHasBeenSaved#message",
		failedToSaveAction: "actionEditor:toasts.failedToSaveAction#message"
	},
	other: {
		historyNotAvailableYet: "actionEditor:other.historyNotAvailableYet#tooltip"
	}
};
